import { Axios } from '@/config/axios'

const state = {
}

const getters = {
}

const actions = {
    getCustomerTokenId ({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(`/api/tenants/customer-token?ohpEuid=${data.adminOhpEuid}`).then((response) => {
                resolve(response.data.data)
            })
                .catch(function (error) {
                    reject(error.response)
                })
        })
    },
    countNbAgent ({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(`/api/tenants/count-agent?ohpEuid=${data}`).then((response) => {
                resolve(response.data.data)
            })
                .catch(function (error) {
                    reject(error.response)
                })
        })
    }
}

const mutations = {
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
